<template>
  <v-app>
    <v-overlay v-model="isLoading" class="centered-overlay" persistent>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <router-view />
  </v-app>
</template>

<script>
import router from './router';

export default {
  name: "App",

  data() {
    return {
      authUserId: null,
      sessionKey: null,
    };
  },

  computed: {
    currentPath() {
      return router.currentRoute.value.fullPath;
    },
  },

  watch: {
    currentPath(newPath) {
      this.checkAuthAndRedirect(newPath);
    },
  },

  mounted() {
  setTimeout(() => {
    this.checkAuthAndRedirect(this.currentPath);
  }, 1);
},

  methods: {
    checkAuthAndRedirect(currentPath) {  
      this.authUserId = localStorage.getItem("authUserId");
      this.sessionKey = localStorage.getItem("sessionKey");

      if (!this.authUserId && !this.sessionKey && !currentPath === "/guestSkillSheet") {
        console.log("認証失敗！", "authUserId: ", this.authUserId, "sessionKey: ", this.sessionKey);
        router.push("/login");
      } else if (currentPath === "/") {
        router.push("/login");
        console.log("現在、画面が存在しません。ログイン画面に遷移します", currentPath);
      } else {
        console.log("認証情報を確認しました。", "currentPath: ", currentPath);
      }
    },
  },
};
</script>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import eventBus from './eventBus'

const isLoading = ref(false)

// const show = () => isLoading.value = true
// const hide = () => isLoading.value = false

onMounted(() => {
  eventBus.on('loading', val => {
    isLoading.value = val
  })
})

onUnmounted(() => {
  eventBus.off('loading')
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.centered-overlay {
  z-index: 9999 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
</style>
